import gql from "graphql-tag";

export const GET_PAYMENT_TYPES = gql`
query paymentTypes{
  paymentTypes: PaymentType{
    id
    name
  }
}`